import { useQuery } from "react-query";
import {
  fetchAllTerminals,
  getTerminalPaymentSession,
} from "../../../services/pos-terminals";

export const useGetTerminals = ({ queries = "" }) => {
  return useQuery(
    ["fetchTerminals", queries],
    () => fetchAllTerminals(queries).then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetTerminalPaymentSession = ({
  transaction_id,
  terminal_id,
  paymentStatus = null,
  hitThirdParty = false,
  onSuccess = () => {},
}) => {
  return useQuery(
    ["getTerminalPaymentSession", `${terminal_id}`, `${transaction_id}`],
    () =>
      getTerminalPaymentSession({
        terminal_id,
        transaction_id,
        hitThirdParty,
      }).then((res) => res.data?.data),
    {
      enabled: transaction_id ? true : false,
      staleTime:
        paymentStatus === "PENDING" || paymentStatus === "PROCESSING"
          ? 5000
          : Infinity,
      refetchInterval:
        paymentStatus === "PENDING" || paymentStatus === "PROCESSING"
          ? 5000
          : Infinity,
      onSettled: () => onSuccess(),
    },
  );
};
